module.exports = __webpack_public_path__ + "img/Kudrat Kahlon, Co-Director of Events, Schulich Finance Association.6c4c16fd.webp";